// M09 - Whitelist client-side de mimetypes/extensiones.
//
// Espejo del whitelist del server (server/constants/educaFiles.js). El
// server es la fuente de verdad; este modulo solo da feedback inmediato
// en el wizard antes de pedir la signed URL.

export const MAX_BYTES = 8 * 1024 * 1024 * 1024; // 8 GB

export const MIME_TO_KIND = {
  "image/jpeg": "image",
  "image/png": "image",
  "image/webp": "image",
  "image/gif": "image",
  "image/svg+xml": "image",
  "video/mp4": "video",
  "video/webm": "video",
  "video/quicktime": "video",
  "audio/mpeg": "audio",
  "audio/wav": "audio",
  "audio/mp4": "audio",
  "audio/x-m4a": "audio",
  "application/pdf": "doc",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "doc",
  "application/vnd.ms-excel": "doc",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "doc",
  "application/vnd.ms-powerpoint": "doc",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "doc",
  "application/zip": "archive",
  "application/x-zip-compressed": "archive",
  "application/x-rar-compressed": "archive",
  "application/vnd.rar": "archive",
  "application/x-7z-compressed": "archive",
};

export const EXT_TO_KIND = {
  jpg: "image",
  jpeg: "image",
  png: "image",
  webp: "image",
  gif: "image",
  svg: "image",
  mp4: "video",
  webm: "video",
  mov: "video",
  mp3: "audio",
  wav: "audio",
  m4a: "audio",
  pdf: "doc",
  doc: "doc",
  docx: "doc",
  xls: "doc",
  xlsx: "doc",
  ppt: "doc",
  pptx: "doc",
  zip: "archive",
  rar: "archive",
  "7z": "archive",
};

export const ACCEPT_ATTR = Object.keys(MIME_TO_KIND).join(",");

export function extOf(filename) {
  const m = String(filename || "").match(/\.([^./\\]+)$/);
  return m ? m[1].toLowerCase() : "";
}

export function validateFile(file) {
  if (!file) return { ok: false, reason: "Sin fichero" };
  if (file.size > MAX_BYTES) {
    return {
      ok: false,
      reason: `El fichero supera el limite de ${MAX_BYTES / (1024 * 1024 * 1024)} GB`,
    };
  }
  const mime = String(file.type || "").toLowerCase();
  const ext = extOf(file.name);
  const kindByMime = MIME_TO_KIND[mime];
  const kindByExt = EXT_TO_KIND[ext];
  if (!kindByMime && !kindByExt) {
    return { ok: false, reason: "Tipo de fichero no permitido" };
  }
  if (kindByMime && kindByExt && kindByMime !== kindByExt) {
    return { ok: false, reason: "Tipo y extension no coinciden" };
  }
  return { ok: true, kind: kindByMime || kindByExt, mime, ext };
}
